/* eslint-disable no-param-reassign */
export default (
  state,
  {
    meta: {
      arg: {
        modal: { modalId },
      },
    },
  }
) => {
  delete state[modalId];
};
